import * as React from "react";
import Category from "@templates/category";
import Grid from "@components/Grid/Grid";
import {inject} from "mobx-react";

@inject("store")
export default class FilterPagePopup extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const model = this.props.navigation.pageContent;//model;
        
        const popupGrid = <Grid
            {...this.props}
            model={model.AdditionalData && model.AdditionalData["Popup"].grid}
            resetProductIterator={this.resetProductIterator}
            // pickProduct={this.pickProduct}
            // productsCount={this.productsCount}
            readMoreAfterRows={-1}
            returnUrl={model.AdditionalData && model.AdditionalData["ReturnUrl"]}
        />;

        const topGrid = <Grid
            {...this.props}
            model={model.Properties.heroGrid}
            //resetProductIterator={this.resetProductIterator}
            // pickProduct={this.pickProduct}
            // productsCount={this.productsCount}
            readMoreAfterRows={1}
        />;
        
        
        //return <div>FilterPagePopup</div>

         return(<Category {...this.props}>
                 {popupGrid}
                 {topGrid}
             </Category>);
        
    }
}

